export const EMPLOYEES_URL_PATH = '/api/v2/employees';
export const EMPLOYEES_MSW_STATUS_KEY = 'employeesAPI';
export const EMPLOYEES_KEY = 'EMPLOYEES';
